var map = {
	"./default-BFT.svg": "4196",
	"./default-BIO.svg": "6661",
	"./default-BVC.svg": "9bee",
	"./default-CARBON.svg": "695f",
	"./default-CBC.svg": "f480",
	"./default-CFT.svg": "56ce",
	"./default-EFT.svg": "b4c4",
	"./default-ESC.svg": "ddea",
	"./default-avatar.svg": "7fab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a4e1";